export default __webpack_public_path__ + "static/media/circle-chevrons-left.534ed1b9.svg";